// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import TravelLogoHorizontal from '../_raw/ui/icon_travel_logo_horizontal.svg';

export default withIconProps(TravelLogoHorizontal, {
  shouldSetDefaultSize: true,
  defaultHeight: 32,
  defaultWidth: 192,
});
